import "./App.css"

import React from "react"
import { EventEmitter } from "./events"
import Innovations from "./components/innovations/Innovations"
import UserModel from "./model/UserModel"
import SafetyTips from "./components/safetyTips/SafetyTips"
import PlayLearnEarn from "./components/playLearnEarn/PlayLearnEarn"
import Played from "./components/played/Played"
import RedeemModule from "./components/redeemModule/RedeemModule"
import RedeemCoupon from "./components/redeemCoupon/RedeemCoupon"
import Profile from "./components/profile/Profile"
import LeaderBoardModule from "./components/LeaderBoardModule/LeaderBoardModule"
import LeaderBoard from "./components/LeaderBoardModule/LeaderBoard/LeaderBoard"
import Modal from "react-bootstrap/Modal"

// import { ToastContainer, toast, Bounce } from "react-toastify"
// import "react-toastify/dist/ReactToastify.css"
import ContestModel from "./model/ContestModel"
import StudentSubmissionModel from "./model/StudentSubmissionModel"
import LocalDataModel from "./model/LocalDataModel"
import StartPage from "./components/startpage/StartPage"
import ReadComics from "./components/readComics/readComics"
import FeedbackPage from "./components/feedback/Feedback"
import { ClockLoader } from "react-spinners"
import AlertModel from "./model/AlertModel"
import ContestsModule from "./components/contestsModule/ContestsModule"
import FuelMeter from "./components/fuelMeter/fuelMeter"
import Congrats from "./components/common/Congrats/Congrats"

// Import images
import newIcon from "./assets/img/new_icon.svg"
import profileAvatar from "./assets/img/profile-avatar.jpg"
import submitInnovations from "./assets/img/submit-innovations.png"
import safetyIcon from "./assets/img/safety-icon.gif"
import redeemStar from "./assets/img/redeem-star.gif"
// import playLearnEarnIco from "./assets/img/play-learn-earn-ico.gif"
import stogoLogo from "./assets/img/stogo-logo.svg"
import closeBtn from "./assets/img/close-btn.svg"
import feedbackImg from "./assets/img/feedback.svg"

export default class App extends React.Component {
  constructor(props) {
    super(props)

    const urlParams = new URLSearchParams(window.location.search)
    const token = urlParams.get("token")

    this.userData = null
    this.state = {
      leaderBoardType: "weekly",
      allTimeLeaders: [],
      allTimeCurrentUserRank: [],
      user: {},
      total_players: 0,
      recent_players: [],
      token: token,
      userAuthenticated: false,
      isFirstTimeUser: true,

      profileOpened: false,
      submitChallengeOpened: false,
      playNowOpened: false,
      redeemOpened: false,

      confettiShown: false,

      newChallenge: false,
      newContest: false,
      contestExpiringSoon: false, 
    }
    this.userModel = new UserModel()
    this.localStorageModel = new LocalDataModel()
    this.alertModel = new AlertModel()
    this.setLocalTempUser = this.setLocalTempUser.bind(this)
    this.setLocalTempUser()

    this.contestModel = new ContestModel()
    this.studentSubmissionModel = new StudentSubmissionModel()

    this.refreshUserData = this.refreshUserData.bind(this)
    this.switchLeaderBoard = this.switchLeaderBoard.bind(this)
    this.fetchContestInfo = this.fetchContestInfo.bind(this)
    this.fetchAcceptedSubmissions = this.fetchAcceptedSubmissions.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.toggleProfile = this.toggleProfile.bind(this)
    this.toggleSubmitChallenge = this.toggleSubmitChallenge.bind(this)
    this.togglePlayNow = this.togglePlayNow.bind(this)
    this.toggleRedeem = this.toggleRedeem.bind(this)
    this.fetchAlerts = this.fetchAlerts.bind(this)
    this.fetchPageLoadData = this.fetchPageLoadData.bind(this)
  }

  async getAuthUserData() {
    if (this.state.token) {
      let userData = await this.userModel.AuthenticateUser(this.state.token)
      if (userData) {
        this.userData = userData
        EventEmitter.dispatch("userAuthenticated")
      }
    } else {
      this.userData = this.userModel.GetUserFromLocal() 
      if (this.userData) {
        let token = this.userData.data.api_token 
        if (token !== null) {
          this.fetchPageLoadData()
        }
      }
    }
  }

  setLocalTempUser() {
    if (!this.localStorageModel.GetLocalData()) {
      let user = {
        User: '{"data":{"id":"11","firebase_id":"","name":"User","email":"user@mail.com","mobile":"","type":"gmail","profile":"https://lh3.googleusercontent.com/a/ACg8ocLP_htyJcmtkyC2GbvAcjhoSlQT9m4rGIQ0mjUeeDH0=s96-c","fcm_id":"","coins":"216","refer_code":"uAz011","friends_code":"","remove_ads":"0","status":"1","date_registered":"2023-11-17 16:37:23","api_token":"","userStatics":{},"userProfileStatics":{"id":"11","firebase_id":"","name":"User","email":"user@mail.com","mobile":"","type":"gmail","profile":"https://lh3.googleusercontent.com/a/ACg8ocLP_htyJcmtkyC2GbvAcjhoSlQT9m4rGIQ0mjUeeDH0=s96-c","fcm_id":"","coins":"28977","credits":"29792","refer_code":"uAz011","friends_code":"","status":"1","date_registered":"2023-11-17 16:37:23","remove_ads":"0","all_time_score":"227","all_time_rank":"1"},"userContestCount":{"id":"11","contests_played":"0","total_score":"0"}},"isLogin":true,"token":""}',
        Languages:
          '{"list":[{"id":"2","language":"Arabic","code":"ar"},{"id":"5","language":"English (UK)","code":"en-GB"},{"id":"14","language":"English (US)","code":"en"},{"id":"34","language":"Malayalam","code":"ml"}],"loading":false,"lastFetch":1707509309188,"currentLanguage":{"id":"14","code":"en","name":"English (US)"}}',
        Settings:
          '{"data":[{"id":"1","type":"about_us","message":"<p>Welcome to <strong>Stogo world</strong></p>\\r\\n<p>Best Android app for elite quiz is here. We guarantee you the best quizing experience for your dedicated users.</p>\\r\\n<p>&nbsp;</p>\\r\\n<p>Made with &lt;3 by <a href=\\"https://wrteam.in\\"><strong>WRTeam</strong></a></p>"},{"id":"2","type":"contact_us","message":"<p>Contact Us</p>"},{"id":"3","type":"instructions","message":"<p><strong>Instructions</strong></p>\\r\\n<p>Elite Quiz game has 4 or 5 options</p>\\r\\n<p>For each right answer 5 points will be given.</p>\\r\\n<p>Minus 2 points for each question.</p>\\r\\n<p>&nbsp;</p>\\r\\n<p><strong>Use of Lifeline</strong> : You can use only once per level</p>\\r\\n<p><strong>50 - 50</strong> : For remove two option out of four (deduct 4 coins).</p>\\r\\n<p><strong>Skip question</strong> : You can pass question without minus points(deduct 4 coins).</p>\\r\\n<p><strong>Audience poll</strong> : Use audience poll to&nbsp;check other users choose option(deduct 4&nbsp;coins).</p>\\r\\n<p><strong>Reset timer</strong> : Reset timer again if you needed more time score (deduct 4 coins).</p>\\r\\n<p>&nbsp;</p>\\r\\n<p><strong>Leaderboard</strong></p>\\r\\n<p>You can compare your score with other&nbsp;users of app.</p>\\r\\n<p>&nbsp;</p>\\r\\n<p><strong>Contest Rules</strong></p>\\r\\n<p>To provide fair and equal chance of winning to all Elite Quiz readers, the following are the official rules for all contests on Elite Quiz.</p>\\r\\n<p><strong>ELIGIBILITY: </strong>All player/users can play contest.</p>\\r\\n<p><strong>HOW TO ENTER: </strong>User can Play Contest&nbsp;by spending number of coins specified as an entry fees in contest details.</p>\\r\\n<p><strong>CHOICE OF LAW:&nbsp;</strong>All the Contest and Operations are belongs to WRTeam. and Apple is not involved in any way with the contest.&nbsp;</p>\\r\\n<p>&nbsp;</p>"},{"id":"38","type":"fun_n_learn_question","message":"1"},{"id":"4","type":"privacy_policy","message":"<p><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\\r\\n<p><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\\r\\n<p><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\\r\\n<p><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>"},{"id":"5","type":"terms_conditions","message":"<p><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\\r\\n<p>&nbsp;</p>\\r\\n<p><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\\r\\n<p>&nbsp;</p>\\r\\n<p><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>\\r\\n<p><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>"},{"id":"6","type":"answer_mode","message":"1"},{"id":"7","type":"false_value","message":"False"},{"id":"8","type":"true_value","message":"True"},{"id":"9","type":"app_version","message":"1.0.0+1"},{"id":"10","type":"reward_coin","message":"4"},{"id":"11","type":"earn_coin","message":"100"},{"id":"12","type":"refer_coin","message":"50"},{"id":"13","type":"ios_more_apps","message":""},{"id":"14","type":"ios_app_link","message":""},{"id":"15","type":"more_apps","message":"https://play.google.com/store/apps/details?id=com.wrteam.quiz"},{"id":"16","type":"app_link","message":"https://play.google.com/store/apps/details?id=com.wrteam.flutterquiz"},{"id":"17","type":"system_timezone_gmt","message":"+05:30"},{"id":"18","type":"system_timezone","message":"Asia/Kolkata"},{"id":"19","type":"language_mode","message":"1"},{"id":"20","type":"option_e_mode","message":"0"},{"id":"21","type":"total_question","message":"10"},{"id":"22","type":"fix_question","message":"1"},{"id":"23","type":"shareapp_text","message":"Hello, This is a \'simple\' share \\"text\\". User will be happy to read "},{"id":"24","type":"contest_mode","message":"1"},{"id":"25","type":"daily_quiz_mode","message":"0"},{"id":"26","type":"force_update","message":"1"},{"id":"27","type":"fcm_server_key","message":""},{"id":"28","type":"battle_random_category_mode","message":"1"},{"id":"29","type":"battle_group_category_mode","message":"1"},{"id":"30","type":"app_name","message":"Stogo Quiz"},{"id":"31","type":"full_logo","message":"1623225017.png"},{"id":"32","type":"half_logo","message":"1623225021.png"},{"id":"33","type":"jwt_key","message":"set_your_strong_jwt_secret_key"},{"id":"34","type":"system_version","message":"2.1.2"},{"id":"35","type":"system_key","message":"$2y$10$HzGScX/jWRc0MgE5SIN9Lu7MCpf2D1AV8W1rWbrOkgNRq36n3wjDC"},{"id":"36","type":"configuration_key","message":"$2y$10$Ftv8MRLm5IfAkprJrcnSkelJMoY8uIUcB3RapZW0GopU0SrkkyFR."},{"id":"39","type":"guess_the_word_question","message":"1"},{"id":"40","type":"audio_mode_question","message":"1"},{"id":"41","type":"total_audio_time","message":"10"},{"id":"42","type":"app_version_ios","message":"1.0.0+1"},{"id":"43","type":"in_app_ads_mode","message":"1"},{"id":"44","type":"ads_type","message":"1"},{"id":"45","type":"android_banner_id","message":"Android Banner Id"},{"id":"46","type":"android_interstitial_id","message":"Android Interstitial Id"},{"id":"47","type":"android_rewarded_id","message":"Android Rewarded Id"},{"id":"48","type":"ios_banner_id","message":"IOS Banner Id"},{"id":"49","type":"ios_interstitial_id","message":"IOS Interstitial Id"},{"id":"50","type":"ios_rewarded_id","message":"IOS Rewarded Id"},{"id":"56","type":"ios_fb_banner_id","message":"YOUR_PLACEMENT_ID"},{"id":"55","type":"android_fb_rewarded_id","message":"YOUR_PLACEMENT_ID"},{"id":"54","type":"android_fb_interstitial_id","message":"YOUR_PLACEMENT_ID"},{"id":"53","type":"android_fb_banner_id","message":"YOUR_PLACEMENT_ID"},{"id":"57","type":"ios_fb_interstitial_id","message":"YOUR_PLACEMENT_ID"},{"id":"58","type":"ios_fb_rewarded_id","message":"YOUR_PLACEMENT_ID"},{"id":"59","type":"exam_module","message":"1"},{"id":"60","type":"payment_mode","message":"1"},{"id":"61","type":"payment_message","message":"test"},{"id":"62","type":"per_coin","message":"10"},{"id":"63","type":"coin_amount","message":"1"},{"id":"64","type":"coin_limit","message":"100"},{"id":"65","type":"self_challenge_mode","message":"0"},{"id":"66","type":"in_app_purchase_mode","message":"1"},{"id":"67","type":"difference_hours","message":"48"},{"id":"68","type":"app_maintenance","message":"0"},{"id":"69","type":"maths_quiz_mode","message":"1"},{"id":"71","type":"android_game_id","message":"Android Game Id"},{"id":"72","type":"ios_game_id","message":"IOS Game Id"},{"id":"73","type":"maximum_winning_coins","message":"4"},{"id":"74","type":"maximum_coins_winning_percentage","message":"70"},{"id":"75","type":"score","message":"4"},{"id":"76","type":"quiz_zone_duration","message":"30"},{"id":"77","type":"self_challange_max_minutes","message":"30"},{"id":"78","type":"guess_the_word_seconds","message":"60"},{"id":"79","type":"maths_quiz_seconds","message":"30"},{"id":"80","type":"fun_and_learn_time_in_seconds","message":"60"},{"id":"81","type":"battle_mode_one","message":"1"},{"id":"82","type":"battle_mode_group","message":"1"},{"id":"83","type":"true_false_mode","message":"1"},{"id":"84","type":"audio_seconds","message":"30"},{"id":"85","type":"random_battle_seconds","message":"30"},{"id":"86","type":"welcome_bonus_coin","message":"10"},{"id":"87","type":"lifeline_deduct_coin","message":"10"},{"id":"88","type":"random_battle_entry_coin","message":"10"},{"id":"89","type":"guess_the_word_max_winning_coin","message":"10"},{"id":"90","type":"review_answers_deduct_coin","message":"10"},{"id":"91","type":"currency_symbol","message":"$"}],"loading":false,"systemConfig":{"system_timezone":"Asia/Kolkata","system_timezone_gmt":"+05:30","app_link":"https://play.google.com/store/apps/details?id=com.wrteam.flutterquiz","more_apps":"https://play.google.com/store/apps/details?id=com.wrteam.quiz","ios_app_link":"","ios_more_apps":"","refer_coin":"50","earn_coin":"100","reward_coin":"4","app_version":"1.0.0+1","app_version_ios":"1.0.0+1","true_value":"True","false_value":"False","shareapp_text":"Hello, This is a \'simple\' share \\"text\\". User will be happy to read ","answer_mode":"1","language_mode":"1","option_e_mode":"0","force_update":"1","daily_quiz_mode":"0","contest_mode":"1","maths_quiz_mode":"1","fix_question":"1","total_question":"10","battle_random_category_mode":"1","battle_group_category_mode":"1","fun_n_learn_question":"1","guess_the_word_question":"1","exam_module":"1","audio_mode_question":"1","self_challenge_mode":"0","in_app_purchase_mode":"1","in_app_ads_mode":"1","ads_type":"1","android_banner_id":"Android Banner Id","android_interstitial_id":"Android Interstitial Id","android_rewarded_id":"Android Rewarded Id","ios_banner_id":"IOS Banner Id","ios_interstitial_id":"IOS Interstitial Id","ios_rewarded_id":"IOS Rewarded Id","android_game_id":"Android Game Id","ios_game_id":"IOS Game Id","payment_mode":"1","payment_message":"test","per_coin":"10","coin_amount":"1","currency_symbol":"$","coin_limit":"100","difference_hours":"48","app_maintenance":"0","maximum_winning_coins":"4","maximum_coins_winning_percentage":"70","score":"4","quiz_zone_duration":"30","self_challange_max_minutes":"30","guess_the_word_seconds":"60","maths_quiz_seconds":"30","fun_and_learn_time_in_seconds":"60","battle_mode_one":"1","battle_mode_group":"1","true_false_mode":"1","audio_seconds":"30","random_battle_seconds":"30","welcome_bonus_coin":"10","lifeline_deduct_coin":"10","random_battle_entry_coin":"10","guess_the_word_max_winning_coin":"10","review_answers_deduct_coin":"10","bot_image":"https://quiz.stogo.world/admin/images/bot-stock.png"}}',
        Tempdata:
          '{"data":{"contest_id":"11","entry_coin":"0"},"contestLeaderboarddata":{"past_id":"8"},"playwithfrienddata":{},"examQuestionData":[],"examCompletedata":{"totalQuestions":null,"Correctanswer":null,"InCorrectanswer":null},"examsetQuiz":{"remianingtimer":null,"statistics":null,"totalmarks":""}}',
        Bookmark: '{"data":{}}',
        GroupBattle: "{}",
        Badges:
          '{"data":{"dashing_debut":{"id":"1","type":"dashing_debut","badge_label":"Dashing Debut","badge_note":"Play first quiz zone game","badge_reward":"2","badge_icon":"https://quiz.stogo.world/admin/images/badges/1636692664.png","badge_counter":"1","status":"0"},"combat_winner":{"id":"2","type":"combat_winner","badge_label":"Combat Winner","badge_note":"Won random battle. If both users have completed the battle then the badge will unlock.","badge_reward":"5","badge_icon":"https://quiz.stogo.world/admin/images/badges/16366926641.png","badge_counter":"1","status":"0"},"clash_winner":{"id":"3","type":"clash_winner","badge_label":"Clash Winner","badge_note":"Won group battle. If a minimum of one opponent user has completed the battle then the badge will unlock.","badge_reward":"2","badge_icon":"https://quiz.stogo.world/admin/images/badges/16366926642.png","badge_counter":"1","status":"0"},"most_wanted_winner":{"id":"4","type":"most_wanted_winner","badge_label":"Most Wanted Winner","badge_note":"Won contest","badge_reward":"10","badge_icon":"https://quiz.stogo.world/admin/images/badges/16366926643.png","badge_counter":"1","status":"1"},"ultimate_player":{"id":"5","type":"ultimate_player","badge_label":"Ultimate Player","badge_note":"Highest point Gainer","badge_reward":"1","badge_icon":"https://quiz.stogo.world/admin/images/badges/16366926644.png","badge_counter":"0","status":"0"},"quiz_warrior":{"id":"6","type":"quiz_warrior","badge_label":"Quiz Warrior","badge_note":"Won back-to-back three random battles.  If both users have completed the battle then the badge will unlock.","badge_reward":"1","badge_icon":"https://quiz.stogo.world/admin/images/badges/16366926645.png","badge_counter":"3","status":"0"},"super_sonic":{"id":"7","type":"super_sonic","badge_label":"Super Sonic","badge_note":"Fastest puzzle solver. Need minimum 5 questions to unlock this badge.","badge_reward":"1","badge_icon":"https://quiz.stogo.world/admin/images/badges/16366926646.png","badge_counter":"25","status":"0"},"flashback":{"id":"8","type":"flashback","badge_label":"Flashback","badge_note":"Average time to solve fun & learn quiz questions. Need minimum 5 questions to unlock this badge.","badge_reward":"1","badge_icon":"https://quiz.stogo.world/admin/images/badges/16366926647.png","badge_counter":"8","status":"0"},"brainiac":{"id":"9","type":"brainiac","badge_label":"Brainiac","badge_note":"Completed 100% quiz without using a lifeline. Need minimum 5 questions to unlock this badge.","badge_reward":"1","badge_icon":"https://quiz.stogo.world/admin/images/badges/16366926648.png","badge_counter":"0","status":"0"},"big_thing":{"id":"10","type":"big_thing","badge_label":"Big Thing","badge_note":"5k correct answer","badge_reward":"1","badge_icon":"https://quiz.stogo.world/admin/images/badges/16366926649.png","badge_counter":"5000","status":"0"},"elite":{"id":"11","type":"elite","badge_label":"Elite","badge_note":"Earn coins more than 5k ","badge_reward":"1","badge_icon":"https://quiz.stogo.world/admin/images/badges/163669266410.png","badge_counter":"200","status":"1"},"thirsty":{"id":"12","type":"thirsty","badge_label":"Thirty","badge_note":"Play daily quiz continuously 30 days","badge_reward":"1","badge_icon":"https://quiz.stogo.world/admin/images/badges/163669266411.png","badge_counter":"30","status":"0"},"power_elite":{"id":"13","type":"power_elite","badge_label":"Power Elite","badge_note":"Achieved more than 10 badges","badge_reward":"1","badge_icon":"https://quiz.stogo.world/admin/images/badges/163669266412.png","badge_counter":"10","status":"0"},"sharing_caring":{"id":"14","type":"sharing_caring","badge_label":"Sharing is Caring","badge_note":"Share application to more than 50 users","badge_reward":"1","badge_icon":"https://quiz.stogo.world/admin/images/badges/163669266413.png","badge_counter":"50","status":"0"},"streak":{"id":"15","type":"streak","badge_label":"Streak","badge_note":"Maintain streak for 30 days","badge_reward":"1","badge_icon":"https://quiz.stogo.world/admin/images/badges/163669266414.png","badge_counter":"30","status":"0"}}}',
        WebSettings:
          '{"data":{"favicon":"https://quiz.stogo.world/admin/images/web-settings/favicon-1696582985.png","header_logo":"https://quiz.stogo.world/admin/images/web-settings/header_logo-1696582985.png","footer_logo":"https://quiz.stogo.world/admin/images/web-settings/footer_logo-1696582985.png","sticky_header_logo":"https://quiz.stogo.world/admin/images/web-settings/sticky_header_logo-1696582985.png","quiz_zone_icon":"https://quiz.stogo.world/admin/images/web-settings/quiz_zone_icon-1680083222.svg","daily_quiz_icon":"https://quiz.stogo.world/admin/images/web-settings/daily_quiz_icon-1680083222.svg","true_false_icon":"https://quiz.stogo.world/admin/images/web-settings/true_false_icon-1680263423.svg","fun_learn_icon":"https://quiz.stogo.world/admin/images/web-settings/fun_learn_icon-1680083222.svg","self_challange_icon":"https://quiz.stogo.world/admin/images/web-settings/self_challange_icon-1680083222.svg","contest_play_icon":"https://quiz.stogo.world/admin/images/web-settings/contest_play_icon-1680083222.svg","one_one_battle_icon":"https://quiz.stogo.world/admin/images/web-settings/one_one_battle_icon-1680083222.svg","group_battle_icon":"https://quiz.stogo.world/admin/images/web-settings/group_battle_icon-1680083222.svg","audio_question_icon":"https://quiz.stogo.world/admin/images/web-settings/audio_question_icon-1680083222.svg","math_mania_icon":"https://quiz.stogo.world/admin/images/web-settings/math_mania_icon-1680083222.svg","exam_icon":"https://quiz.stogo.world/admin/images/web-settings/exam_icon-1680083222.svg","guess_the_word_icon":"https://quiz.stogo.world/admin/images/web-settings/guess_the_word_icon-1680083222.svg","section1_heading":"Why Choose Us ","section1_cover_image":"https://quiz.stogo.world/admin/images/web-home-settings/section1_cover_image-1689922021.jpg","section1_title1":"Easy to Use","section1_title2":"Many Quiz Zone","section1_title3":"Unique Admin Panel","section1_image_title_title1":"Life Lines","section1_image_title_title2":"Leaderboard","section1_image_title_title3":"Battle Quiz","section1_image_title_title4":"Many Level","section1_image_title_image1":"https://quiz.stogo.world/admin/images/web-home-settings/section1_image_title_image1-1689673572.svg","section1_image_title_image2":"https://quiz.stogo.world/admin/images/web-home-settings/section1_image_title_image2-1689673572.svg","section1_image_title_image3":"https://quiz.stogo.world/admin/images/web-home-settings/section1_image_title_image3-1689673572.svg","section1_image_title_image4":"https://quiz.stogo.world/admin/images/web-home-settings/section1_image_title_image4-1689673572.svg","section2_heading":"Incredible Quiz Features","section2_cover_image":"https://quiz.stogo.world/admin/images/web-home-settings/section2_cover_image-1689673572.jpg","section2_title_desc_title1":"Quiz Battle Royal","section2_title_desc_title2":"Fun Learning Quizzes","section2_title_desc_title3":"Self-Improvement Challenges","section2_title_desc_title4":"Guess the Word","section2_title_desc_desc1":"Challenge your friends, conquer the competition, and prove your intellectual prowes.","section2_title_desc_desc2":"Expand your knowledge with trivia that\'s both entertaining and informative.","section2_title_desc_desc3":"Put your skills to the test and see how you measure up.","section2_title_desc_desc4":"Can you solve it? Get ready for an exciting challenge!","section3_heading":"Stogo Quiz Best Part","section3_title_image_desc_title1":"Regular Udpates","section3_title_image_desc_title2":"Competitive Fun","section3_title_image_desc_title3":"Global Community","section3_title_image_desc_title4":"All-age Inclusivity","section3_title_image_desc_image1":"https://quiz.stogo.world/admin/images/web-home-settings/section3_title_image_desc_image1-1689673572.svg","section3_title_image_desc_image2":"https://quiz.stogo.world/admin/images/web-home-settings/section3_title_image_desc_image2-1689673572.svg","section3_title_image_desc_image3":"https://quiz.stogo.world/admin/images/web-home-settings/section3_title_image_desc_image3-1689673572.svg","section3_title_image_desc_image4":"https://quiz.stogo.world/admin/images/web-home-settings/section3_title_image_desc_image4-1689673572.svg","section3_title_image_desc_desc1":"Regularly Updated Quizzes for a Fresh and Exciting Learning Experience.","section3_title_image_desc_desc2":"Test Your Knowledge and Challenge Others. Compete, Test, Challenge!","section3_title_image_desc_desc3":"Join the Elite Quiz Global Community and Expand Your Knowledge Together!","section3_title_image_desc_desc4":"Elite Quiz for Kids, Teens, & Adults - Fun Learning for Everyone!","firebase_api_key":"AIzaSyA4Zwz3VoCypw2vjVQSEq9DYw5J02ZncRY","firebase_auth_domain":"quiz-stogo-world.firebaseapp.com","firebase_database_url":"","firebase_project_id":"quiz-stogo-world","firebase_storage_bucket":"quiz-stogo-world.appspot.com","firebase_messager_sender_id":"77047098875","firebase_app_id":"1:77047098875:web:479cb384068c5c8c70af5e","firebase_measurement_id":"G-CSXKDH0E19","meta_description":"quiz","meta_keywords":"quiz","rtl_support":"0","company_name_footer":"Tachyon360","email_footer":"smanitha@takyonline.com","phone_number_footer":"","web_link_footer":"","facebook_link_footer":"","instagram_link_footer":"","linkedin_link_footer":"","youtube_link_footer":"","company_text":"","address_text":""},"loading":false}',
        _persist: '{"version":-1,"rehydrated":true}',
      }

      this.localStorageModel.SetLocalData(user)
    }
  }

  componentDidMount() {
    window.onpopstate = () => {
      window.location.reload();
    };
    this.getAuthUserData()
    EventEmitter.subscribe("userAuthenticated", (event) => {
      // this.refreshUserData()
      this.fetchPageLoadData()
    })
    EventEmitter.subscribe("quizAttended", (event) => {
      this.fetchContestInfo()
    })
    EventEmitter.subscribe("coinUpdated", (event) => {
      this.refreshUserData()
      let msg = this.prepareToastMessage(event.userPoints)
      this.notify(msg, event.userPoints)
      EventEmitter.dispatch("fetchLeaderBoard")
    })
    EventEmitter.subscribe("submissionAccepted", () => {
      this.refreshUserData()
      this.notify("Submission Accepted")
    })
    EventEmitter.subscribe("offerPurchased", () => {
      this.refreshUserData()
      this.notify("Offer Purchased!")
      EventEmitter.dispatch("redeemedCouponsUpdated")
    })
  }

  fetchPageLoadData() {
    this.fetchContestInfo()
    this.fetchAcceptedSubmissions()
    this.fetchAlerts()

    let isFirstTimeUser = false
    if (parseInt(this.userData.data?.tc_accepted, 10) === 0) {
      isFirstTimeUser = true
    }

    this.setState({
      user: this.userData,
      userAuthenticated: true,
      isFirstTimeUser: isFirstTimeUser,
    })
  }

  async refreshUserData() {
    let user = await this.userModel.GetUser()
    this.setState({ user: user })

    EventEmitter.dispatch("profileUpdated")
  }

  switchLeaderBoard(data) {
    this.setState({
      leaderBoardType: data.type,
      allTimeLeaders: data.leaderBoard,
      allTimeCurrentUserRank: data.currentUserRank,
    })
  }

  notify(msg, points = null) {
    // toast(msg, {
    //   position: "top-right",
    //   autoClose: 10000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    //   theme: "light",
    //   type: "success",
    //   transition: Bounce,
    // })

    if (points !== null) {
      this.setState({ confettiShown: true, attainedPoints: points }, () => {
        setTimeout(() => {
          this.setState({ confettiShown: false, attainedPoints: 0 })
        }, 10000)
      })
    }
  }

  prepareToastMessage(userPoints) {
    return (
      <>
        <div className="bg-anim">
          (<b>{userPoints}</b>)<span> points have been awarded!</span>
        </div>
      </>
    )
  }

  async fetchContestInfo() {
    let contestInfo = await this.contestModel.GetContestInfo()
    let total_players = contestInfo.data?.total_players
    let recent_players = contestInfo.data?.recent_players

    this.setState({
      total_players: total_players,
      recent_players: recent_players,
    })
  }

  async fetchAcceptedSubmissions() {
    let acceptedSubmissions =
      await this.studentSubmissionModel.GetAcceptedStudentSubmissions()
    if (typeof(acceptedSubmissions) === 'object') {
      for (let acceptedSubmission of acceptedSubmissions) {
        let acceptancePrize = acceptedSubmission.activity_acceptance_prize
        EventEmitter.dispatch("submissionAccepted")
        EventEmitter.dispatch("coinUpdated", {
          userPoints: acceptancePrize,
        })
      }
    }

    setTimeout(() => {
      this.fetchAcceptedSubmissions()
    }, 1000)
  }

  handleClose() {
    this.setState({ isFirstTimeUser: false })
  }

  toggleProfile() {
    this.setState((prevState) => {
      return { profileOpened: !prevState.profileOpened }
    })
  }

  toggleSubmitChallenge() {
    this.setState((prevState) => {
      return {
        submitChallengeOpened: !prevState.submitChallengeOpened,
      }
    })
  }

  togglePlayNow() {
    this.setState((prevState) => {
      return {
        playNowOpened: !prevState.playNowOpened,
      }
    })
  }

  toggleRedeem() {
    this.setState((prevState) => {
      return {
        redeemOpened: !prevState.redeemOpened,
      }
    })
  }

  async fetchAlerts() {
    let alerts = await this.alertModel.GetAlerts()
    let newChallenge = false
    let newContest = false
    if (alerts !== null) {
      for (let alert of alerts) {
        if (alert.event_type === "activity_added") {
          newChallenge = true
        } else if (alert.event_type === "contest_added") {
          newContest = true
          const alertEndDate = new Date(alert.end_date); // Convert to Date object
          const currentTime = new Date();
          const timeDiff = alertEndDate - currentTime;
          // console.log("timediff", timeDiff);
          if (timeDiff > 0 && timeDiff <= 24 * 60 * 60 * 1000) {
            this.setState({ contestExpiringSoon: true });
            // console.log("here")
          }
        }

        if (newChallenge && newContest) {
          break
        }
      }
    }
    this.setState({
      newChallenge: newChallenge,
      newContest: newContest,
    })

    setTimeout(() => {
      this.fetchAlerts()
    }, 60000)
  }

  render() {
    let isLoggedIn = this.state.userAuthenticated
    let fuelLevel = this.state.user?.data?.userProfileStatics?.fuel_level

    let confetti = null
    if (this.state.confettiShown) {
      // confetti = <Confetti className="confetti-container" />
      confetti = <Congrats attainedPoints={this.state.attainedPoints} />
    }
    let newChallenge = null
    if (this.state.newChallenge) {
      newChallenge = (
        <div className="new_challenge new-icon">
          <img alt="" src={newIcon} />
        </div>
      )
    }
    let newContest = null
    if (this.state.newContest) {
      newContest = (
        <div className="new_contest new-icon">
          <img alt="" src={newIcon} />
        </div>
      )
    }
    let mainContent = (
      <>
        {/* <ToastContainer /> */}

        <div className="container">          
          <div className="prof-head">
            <div className="dropdown">
              <div
                onClick={this.toggleProfile}
                className="prof"
                data-bs-toggle="modal"
                data-bs-target="#Profile">
                <span>
                  {this.state.user?.data?.name}
                  {/* <i className="fa fa-angle-down" aria-hidden="true"></i> */}
                </span>
                <img alt="" src={profileAvatar} />
              </div>
              {/* <ul className="dropdown-menu">
                <li><a className="dropdown-item" href="!#" data-bs-toggle="modal" data-bs-target="#Profile"><i
                  className="fa fa-user" aria-hidden="true"></i> Profile</a></li>
                <li><a className="dropdown-item" href="!#"><i className="fa fa-lock" aria-hidden="true"></i> Logout</a></li>
              </ul> */}
            </div>
          </div>
        </div>
        <div className="container boxes">
          {/* <div className="rows">
            <FuelMeter fuelLevel={fuelLevel} />
          </div> */} 

          <div className="rows spacer">
            <a><div className="submit-innovations"><FuelMeter fuelLevel={fuelLevel} /></div></a>
            {/* <a
              onClick={this.toggleSubmitChallenge}
              href="!#"
              data-bs-toggle="modal"
              data-bs-target="#ChallengeMonth">
              <div className="submit-innovations">
                {newChallenge}
                <span className="white">Champion’s Challenge:</span>
                <br />
                <span className="yellow">Take the Lead!</span>
                <div className="ico">
                  <img alt="" src={submitInnovations} />
                </div>
              </div>
            </a> */}

            {/* <a
              onClick={this.togglePlayNow}
              href="!#"
              data-bs-toggle="modal"
              data-bs-target="#PlayNow">
              <div className="played" style={{ position: "relative" }}>
                {this.state.contestExpiringSoon && 
                  (<span style={{ marginRight: '4px' }}>⏰ 
                  <span className="red">Contest Expiring Soon!</span>
                  </span>)}
                {newContest}
                <span className="white">{this.state.total_players}</span>
                <br />
                <span className="white">played</span>
                <br />
                <span className="yellow">contests</span>
                
              </div>
            </a> */}

            <a
              onClick={this.togglePlayNow}
              href="!#"
              data-bs-toggle="modal"
              data-bs-target="#PlayNow">
              <div className="played" style={{ position: "relative" }}>                
                {/* Expiring alert banner */}
                {this.state.contestExpiringSoon && (
                  <div className="custom-alert">                    
                    ⏰ Contest Expiring Soon!
                  </div>
                )}

                {newContest}
                <span className="white">{this.state.total_players}</span>
                <br />
                <span className="white">played</span>
                <br />
                <span className="yellow">contests</span>
              </div>
            </a>


            <a href="!#" data-bs-toggle="modal" data-bs-target="#eGuide">
              <div className="esafety">
                <div className="cont">
                  <span className="white">SAFETY</span>
                  <br />
                  <span className="yellow">TIPS</span>
                  <br />
                </div>
                <div className="ico">
                  <img alt="" src={safetyIcon} />
                </div>
              </div>
            </a>

            <a
              onClick={this.toggleRedeem}
              href="!#"
              data-bs-toggle="modal"
              data-bs-target="#PointsEarned">
              <div className="redeem">
                <span className="yellow">
                  {this.state.user?.data?.userProfileStatics?.coins}
                </span>
                <br />
                <span className="white">redeem </span>
                <br />
                <span className="yellow">points</span>
                <div className="ico">
                  <img alt="" src={redeemStar} />
                </div>
              </div>
            </a>

            <LeaderBoardModule
              onSwitch={this.switchLeaderBoard}></LeaderBoardModule>

            {/* <div className="end-container">
              <a
                href="!#"
                data-bs-toggle="modal"
                data-bs-target="#GamesPuzzles">
                <div className="play-learn-earn">
                  <div className="cont">
                    <span className="white">play !</span>
                    <br />
                    <span className="yellow">&</span>
                    <br />
                    <span className="white">learn !</span>
                  </div>
                  <div className="ico">
                    <img alt="" src={playLearnEarnIco} />
                  </div>
                </div>
              </a>
            </div> */}

            
            <div>
            <a href="!#" data-bs-toggle="modal" data-bs-target="#ReadComic">
              <div className="stogo-logo">
                <img alt="" src={stogoLogo} />
              </div>
            </a>
            <br />            
            <a href="!#" data-bs-toggle="modal" data-bs-target="#Feedback" >
                <div className="feedback-logo">
                  <img alt="" src={feedbackImg} />
                </div>
              </a>
          </div>
          </div>
          
        </div>

        <Modal
          show={this.state.isFirstTimeUser}
          onHide={this.handleClose}
          backdrop="static"
          keyboard={false}
          size="lg"
          centered
          contentClassName="read-comic login">
          <div className="pop-banner read-comic"></div>
          <Modal.Body>
            <StartPage onProceed={this.handleClose}></StartPage>
          </Modal.Body>
        </Modal>

        <LeaderBoard
          type={this.state.leaderBoardType}
          allTimeLeaders={this.state.allTimeLeaders}
          allTimeCurrentUserRank={
            this.state.allTimeCurrentUserRank
          }></LeaderBoard>

        <Profile
          opened={this.state.profileOpened}
          onClose={this.toggleProfile}
        />

        <div
          className="modal fade"
          id="ReadComic"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="ReadComic"
          aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content read-comic">
              <a
                href="!#"
                className="close-btn"
                data-bs-dismiss="modal"
                aria-label="Close">
                <img alt="" src={closeBtn} />
              </a>
              <div className="pop-banner read-comic"></div>
              <div className="modal-body">
                <ReadComics></ReadComics>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="Feedback"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="Feedback"
          aria-hidden="true">
          <div className="modal-dialog modal-dialog-left modal-lg">            
            <div className="modal-content feedback">
              <a
                href="!#"
                className="close-btn"
                data-bs-dismiss="modal"
                aria-label="Close">
                <img alt="" src={closeBtn} />
              </a>
              <div className="pop-banner feedback">
                <h1>FEEDBACK FORM</h1>
              </div>
              <div className="modal-body">
                <FeedbackPage></FeedbackPage>
              </div>
            </div>
          </div>
        </div>


        {/* <RedeemModule
          opened={this.state.redeemOpened}
          onClose={this.toggleRedeem}
        /> */}
        <RedeemCoupon
          opened={this.state.redeemOpened}
          onClose={this.toggleRedeem}
        />
        <div
          className="modal fade"
          id="eGuide"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="eGuide"
          aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content eguide">
              <a
                href="!#"
                className="close-btn"
                data-bs-dismiss="modal"
                aria-label="Close">
                <img alt="" src={closeBtn} />
              </a>
              <div className="pop-banner eguide"></div>
              <div className="modal-body">
                <div className="content">
                  <SafetyTips />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="GamesPuzzles"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="GamesPuzzles"
          aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content games-puzzles">
              <a
                href="!#"
                className="close-btn"
                data-bs-dismiss="modal"
                aria-label="Close">
                <img alt="" src={closeBtn} />
              </a>
              <div className="pop-banner games-puzzles">
                <h1>GAMES & PUZZLES</h1>
              </div>
              <div className="modal-body">
                <div className="content">
                  <PlayLearnEarn />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="PlayNow"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="PlayNow"
          aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content play-now">
              <a
                onClick={this.togglePlayNow}
                href="!#"
                className="close-btn"
                data-bs-dismiss="modal"
                aria-label="Close">
                <img alt="" src={closeBtn} />
              </a>
              <div className="pop-banner play-now"></div>
              <div className="modal-body">
                <div className="content">
                  {(() => {
                    if (this.state.playNowOpened) {
                      return (
                        <Played recentPlayers={this.state.recent_players} />
                      )
                    }
                  })()}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="ChallengeMonth"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="ChallengeMonth"
          aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content challenge-month">
              <a
                onClick={this.toggleSubmitChallenge}
                href="!#"
                className="close-btn"
                data-bs-dismiss="modal"
                aria-label="Close">
                <img alt="" src={closeBtn} />
              </a>
              <div className="pop-banner challenge-month">
                <h1>CHALLENGE OF THE MONTH</h1>
              </div>
              <div className="modal-body">
                <div className="content">
                  {(() => {
                    if (this.state.submitChallengeOpened) {
                      return <Innovations />
                    }
                  })()}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="LiveContests"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="LiveContests"
          aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content contests">
              <a
                href="!#"
                className="close-btn"
                data-bs-dismiss="modal"
                aria-label="Close">
                <img alt="" src={closeBtn} />
              </a>
              <div className="pop-banner contests">
                <h1>CONTESTS</h1>
              </div>
              <div className="modal-body">
                <div className="content">
                  <ContestsModule />
                </div>
              </div>
            </div>
          </div>
        </div>

        {confetti}
      </>
    )
    if (!isLoggedIn) {
      mainContent = (
        <>
          <div className="container boxes">
            <div className="app-loading">
              <ClockLoader
                loading="true"
                color="grey"
                aria-label="Loading Spinner"
                size={150}
                data-testid="loader"></ClockLoader>
            </div>
          </div>
        </>
      )
    }

    return mainContent
  }
}
